import { render, staticRenderFns } from "./cargoWarehousing.vue?vue&type=template&id=324486e4&scoped=true"
import script from "./cargoWarehousing.vue?vue&type=script&lang=js"
export * from "./cargoWarehousing.vue?vue&type=script&lang=js"
import style0 from "./cargoWarehousing.vue?vue&type=style&index=0&id=324486e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324486e4",
  null
  
)

export default component.exports